import { render } from "./roles-and-access-layout.vue?vue&type=template&id=08225c14&scoped=true"
import script from "./roles-and-access-layout.vue?vue&type=script&lang=js"
export * from "./roles-and-access-layout.vue?vue&type=script&lang=js"

import "./roles-and-access-layout.vue?vue&type=style&index=0&id=08225c14&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08225c14"]])

export default __exports__